/**
 * Widget Renderer - the widget for each ID in the bar's catalog
 */

import type { WidgetProps, WidgetId } from "@/types/widget";

import { CalendarBarWidget } from "./bar/CalendarBarWidget";
import { ClockBarWidget } from "./bar/ClockBarWidget";
import { PromptsBarWidget } from "./bar/PromptsBarWidget";
import { VoiceBarWidget } from "./bar/VoiceBarWidget";

interface WidgetRendererProps extends WidgetProps {
  widgetId: WidgetId;
}

/**
 * Renders the appropriate widget component based on widget ID
 */
export function renderWidget(widgetId: WidgetId, props: WidgetRendererProps) {
  switch (widgetId) {
    case "calendar":
      return <CalendarBarWidget {...props} />;
    case "clock":
      return <ClockBarWidget {...props} />;
    case "voice-agent":
      return <VoiceBarWidget {...props} />;
    case "prompt-library":
      return <PromptsBarWidget {...props} />;
    default:
      return null;
  }
}
